import { fetchWithAuth } from '../helpers';
import { getApiUrl } from '../config/api';

const handleResponse = async (response: Response) => {
  const data = await response.json();
  if (!response.ok) {
    const error = (data && data.message) || response.statusText;
    return Promise.reject(error);
  }
  return data;
};

const classMonthlySessionService = {
  getAll: async (params: { classId?: number; month?: number; year?: number }) => {
    const qp = new URLSearchParams();
    if (params.classId != null) qp.append('classId', String(params.classId));
    if (params.month != null) qp.append('month', String(params.month));
    if (params.year != null) qp.append('year', String(params.year));
    const response = await fetchWithAuth(`${getApiUrl()}/api/class-monthly-sessions?${qp.toString()}`, {
      method: 'GET',
      headers: { 'ngrok-skip-browser-warning': '69420' },
    });
    return handleResponse(response);
  },

  // Lấy số buổi đã xác nhận theo lớp (dùng cho tính học phí)
  getConfirmedByClass: async (month: number, year: number) => {
    const response = await fetchWithAuth(
      `${getApiUrl()}/api/class-monthly-sessions/confirmed-by-class?month=${month}&year=${year}`,
      { method: 'GET', headers: { 'ngrok-skip-browser-warning': '69420' } }
    );
    return handleResponse(response);
  },

  // Xác nhận buổi học tháng cho 1 lớp
  confirm: async (classId: number, month: number, year: number) => {
    const response = await fetchWithAuth(`${getApiUrl()}/api/class-monthly-sessions/confirm`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '69420' },
      body: JSON.stringify({ classId, month, year }),
    });
    return handleResponse(response);
  },

  // Xác nhận lại (chỉ stamp confirmedAt, GIỮ NGUYÊN sessions đã sửa thủ công)
  reConfirm: async (classId: number, month: number, year: number) => {
    const response = await fetchWithAuth(`${getApiUrl()}/api/class-monthly-sessions/re-confirm`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '69420' },
      body: JSON.stringify({ classId, month, year }),
    });
    return handleResponse(response);
  },

  // Thêm buổi bù thủ công
  addManual: async (data: { classId: number; sessionDate: string; startTime: string; endTime: string; month: number; year: number; note?: string }) => {
    const response = await fetchWithAuth(`${getApiUrl()}/api/class-monthly-sessions/manual`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '69420' },
      body: JSON.stringify(data),
    });
    return handleResponse(response);
  },

  // Sửa 1 buổi học
  update: async (id: number, data: { isActive?: boolean; startTime?: string; endTime?: string; note?: string }) => {
    const response = await fetchWithAuth(`${getApiUrl()}/api/class-monthly-sessions/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '69420' },
      body: JSON.stringify(data),
    });
    return handleResponse(response);
  },

  delete: async (id: number) => {
    const response = await fetchWithAuth(`${getApiUrl()}/api/class-monthly-sessions/${id}`, {
      method: 'DELETE',
      headers: { 'ngrok-skip-browser-warning': '69420' },
    });
    return handleResponse(response);
  },
};

export default classMonthlySessionService;
